import { takeLatest } from 'redux-saga/effects';

import { API_REQ_ACTION_TYPES } from 'api/actions';

import { moveFromRestrictedRoute, refreshUI } from './sagas';

function* watcherSaga() {
  yield takeLatest(
    [API_REQ_ACTION_TYPES.USERS.UPDATE_USER_ACTIVE_TENANT.SUCCESS],
    moveFromRestrictedRoute
  );

  yield takeLatest(
    [API_REQ_ACTION_TYPES.USERS.UPDATE_USER_ACTIVE_TENANT.SUCCESS],
    refreshUI
  );
}

export default watcherSaga;
